import { CheckoutState } from './types'

export const initialState: CheckoutState = {
  currentStep: 1,
  
  shippingAddress: {
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    state: '',
    zipCode: '',
    country: 'Brasil'
  },
  billingAddress: {
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    state: '',
    zipCode: '',
    country: 'Brasil'
  },
  selectedAddressId: null,
  showNewAddressForm: false,
  addressConfirmed: false,
  
  customerInfo: {
    email: '',
    name: '',
    document: ''
  },
  
  shippingOptions: [],
  selectedShippingOption: null,
  isLoadingShipping: false,
  shippingError: null,
  
  appliedCoupons: [],
  couponCode: '',
  isLoadingCoupon: false,
  couponError: null,
  
  selectedPaymentMethod: null,
  clientSecret: null,
  isLoadingPayment: false,
  paymentError: null,
  
  orderId: null,
  isCreatingOrder: false,
  orderError: null,
  
  formErrors: {},
  showPaymentForm: false,
  paymentProcessed: false
}

